export default Object.freeze({
    BASE_API_URL: process.env.VUE_APP_BASE_API_URL,
    BASE_CDE_API_URL: process.env.VUE_APP_BASE_CDE_API_URL,
});
